<template>
  <div :class="['cn-post-block-wrapper', (is_ad) ? 'cn-post-block-wrapper-ad' : '' ]" v-if="itemData">
    <div :class="[(is_ad) ? 'cn-item-post-ad' : '']">
      <!--Image-->
      <a rel="nofollow"
        class="cn-post-pic item-img-ancor"
        href="javascript:void(0)"
        v-on:click="readMore(itemData.id)"
        v-if="(itemData.type === 'image' || mediaType === 'image' || itemData.type === 'photo' || mediaType === 'photo') && media"
      >
        <div class="twitter-play" v-if="tweet_is_video">
          <i class="cn-icon-play" aria-hidden="true"></i>
        </div>
        <img v-lazy="media.replace(/http:|https:/i, '')" :data-post_id="itemData.id" alt v-if="media" v-on:error="mediaError" />
        <!-- place Holder-->

      </a>
      <!--Video-->
      <a rel="nofollow"
        class="cn-post-video"
        href="javascript:void(0)"
        v-if="(itemData.type === 'video' || mediaType === 'video') && media">

        <div v-if="itemData.service === 'youtube'" v-html="itemData.media[0].embed" class="cn-youtube-item"></div>
        <video width="320" height="240" controls v-if="media && itemData.service !== 'youtube'">
          <source :src="media.replace(/http:|https:/i, '')" type="video/mp4" v-on:error="mediaError" />
        </video>
      </a>

      <a rel="nofollow"
        class="cn-post-pic cn-no-underline"
        href="javascript:void(0)"
        v-on:click="readMore(itemData.id)"
        v-if="!media"
      >
        <i class="cn-icon-crowdy"></i>
      </a>

      <!--Body Content-->
      <div class="cn-post-block-inner-wrap">
        <div class="cn-post-header">
          <div class="cn-post-header-left" >
            <img :src="itemData.author.image" v-on:error="itemData.author.image = null" alt v-if="itemData.author.image"/>
            <i v-else class="cn-icon-user-circle" style="font-size:38px;color:#212529;"></i>
          </div>
          <div class="cn-post-header-cen">
            <!--::Todo arrange it -->
            <h3 v-if="itemData.service==='twitter' || itemData.service==='instagram'">
              <a rel="nofollow"
                :href="itemData.author.url"
                target="_blank"
              >{{itemData.author.name || itemData.author.username }}</a>
            </h3>
            <h3 v-else>
              <a rel="nofollow"
                :href="getAuthorURL()"
                target="_blank"
              >{{itemData.author.name || itemData.author.username}}</a>
            </h3>

            <span v-if="itemData.service==='twitter'">@{{itemData.author.username}}</span>
            <span v-else>{{date}}</span>
          </div>
          <div class="cn-post-header-right">
            <a class="cn-no-underline" rel="nofollow" :href="itemData.url" target="_blank">
              <i
                :class="['cn-icon-'+((itemData.service === 'oembed') ? 'rss' : itemData.service)]"
                aria-hidden="true"
              ></i>
            </a>
          </div>
        </div>

        <div class="cn-post-body" v-on:click="readMore(itemData.id)">
          <template v-if="parentDivHeight >= 400 && parentDivHeight <= 500">
            <h1 class="cn-post-title" v-html="itemData.title ? itemData.title.substring(0,37)+'...' : ''"></h1>
            <p v-if="!actionButton" v-html="itemData.text ? itemData.text.substring(0,85)+'...' : ''"></p>
          </template>
          <template v-else>
            <h1 class="cn-post-title" v-html="itemData.title ? itemData.title.substring(0,120)+'...' : ''"></h1>
            <p v-if="!actionButton" v-html="itemData.text ? itemData.text.substring(0,120)+'...' : ''"></p>
          </template>
          <div v-if="actionButton" class="buy-now-main">
            <button class="buy-now">{{actionButtonText}}</button>
          </div>
        </div>

        <!--::Todo Arrange Footers-->
        <div class="cn-post-footer" >
          <div class="cn-post-footer-left">
            <a v-if="!actionButton" rel="nofollow" href="javascript:void(0)" v-on:click="readMore(itemData.id)">Read more</a>
          </div>
          <div class="cn-post-footer-right">
            <ul class="cn-social-links">
              <li>
                <a class="cn-no-underline" rel="nofollow" href="javascript:void(0)" v-on:click="showSharePopup=true">
                  <i class="cn-icon-share-alt"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!--:: Twitter Have this type of footer according to reference -->
        <div class="cn-post-footer" v-if="0">
          <div class="cn-post-footer-left" v-on:click="readMore(itemData.id)">
            <span>{{date}}</span>
          </div>
          <div class="cn-post-footer-right">
            <ul class="cn-social-links">
              <li>
                <a rel="nofollow"
                  :href="'https://twitter.com/intent/tweet?in_reply_to='+itemData.id"
                  title="Reply"
                  target="_blank"
                >
                  <i class="fa fa-reply"></i>
                </a>
              </li>
              <li>
                <a rel="nofollow"
                  :href="'https://twitter.com/intent/retweet?tweet_id='+itemData.id"
                  title="Retweet"
                  target="_blank"
                >
                  <i class="fa fa-retweet"></i>
                </a>
              </li>
              <li>
                <a rel="nofollow"
                  :href="'https://twitter.com/intent/like?tweet_id='+itemData.id"
                  title="Like"
                  target="_blank"
                >
                  <i class="fa fa-heart"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="cn-share-popup" style="display:flex;" v-if="showSharePopup">
        <ul>
              <li><a class="cn-no-underline" rel="nofollow" v-on:click="shareItem" data-type="twitter" :href="'https://twitter.com/intent/tweet?text='+itemData.url" target="_blank"><i class="cn-icon-twitter"></i></a></li>
              <li><a class="cn-no-underline" rel="nofollow" v-on:click="shareItem" data-type="facebook" :href="'https://www.facebook.com/sharer/sharer.php?u='+itemData.url" target="_blank"><i class="cn-icon-facebook"></i></a></li>
              <li><a class="cn-no-underline" rel="nofollow" v-on:click="shareItem" data-type="linkedin" :href="'https://www.linkedin.com/shareArticle?mini=true&url='+itemData.url" target="_blank"><i class="cn-icon-linkedin"></i></a></li>
              <li><a class="cn-no-underline" rel="nofollow" v-on:click="shareItem" data-type="pinterest" :href="'https://pinterest.com/pin/create/button/?url='+itemData.url" target="_blank"><i class="cn-icon-pinterest"></i></a></li>
              <li><a class="cn-no-underline" rel="nofollow" :href="'mailto:info@example.com?&subject=&body='+itemData.url" target="_blank"><i class="cn-icon-envelope"></i></a></li>
        </ul>
        <span class="cn-share-close" v-on:click="showSharePopup=false">
          <i class="cn-icon-close"></i>
        </span>
      </div>
    </div>
    <div class="cn-item-ad" v-if="0 && is_ad">
      <div class="cn-item-ad-head">
        ADVERTISEMENT
      </div>
      <div class="cn-item-ad-body">
          <img src="https://www.disruptivestatic.com/wp-content/uploads/2015/03/AG-ever-336x280-300x250.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'item',
  props: ['itemData', 'linkColor', 'parentDivHeight', 'itemIndex', 'actionButton', 'actionButtonText'],
  data () {
    return {
      media: '',
      mediaType: '',
      tweet_is_video: false,
      date: '',
      showSharePopup: false,
      is_ad: false
    }
  },
  mounted () {
    if (this.itemIndex === 1) {
      this.is_ad = true
    }
    if (this.itemData) {
      if (this.itemData.service === 'youtube') {
        this.media = 'embed'
        this.mediaType = 'video'
      } else {
        this.media = this.itemData.media && this.itemData.media[0].url
          ? this.itemData.media[0].url.includes('/emoji/')
            ? ''
            : this.itemData.media[0].url
          : ''
        this.mediaType = this.itemData.media ? this.itemData.media[0].type : ''
        this.mediaType = this.itemData.service === 'instagram' || this.itemData.service === 'facebook' || this.itemData.service === 'twitter' ? 'photo' : this.mediaType
      }
      var date = new Date(this.itemData.date)
      var month = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ]
      this.date =
        date.getDate() +
        ' ' +
        month[date.getMonth()] +
        ' ' +
        date.getFullYear()
      if (
        this.itemData.service === 'rss' ||
        this.itemData.service === 'oembed'
      ) {
        this.itemData.author.image = this.getFavicon(
          this.getBaseURL(this.itemData.url)
        )
      }
      if (this.itemData.service === 'twitter' && this.media.includes('amplify_video_thumb')) {
        this.tweet_is_video = true
      } else {
        this.tweet_is_video = false
      }
    }
  },
  methods: {
    getAuthorURL () {
      if (this.itemData.author !== 'undefined') {
        var link =
          this.itemData.service === 'twitter' || this.itemData.service === 'youtube'
            ? this.itemData.author.url
            : '//' +
              this.itemData.service +
              '.com/' +
              this.itemData.author.userid
        // ::TODO Clean this code
        if (
          this.itemData.service === 'rss' ||
          this.itemData.service === 'oembed'
        ) {
          link = this.itemData.url
        }
        return link
      }
      return ''
    },
    readMore (itemId) {
      this.$emit('onItemReadMore', itemId)
    },
    mediaError () {
      this.media = false
    },
    getBaseURL (url) {
      var a = document.createElement('a')
      a.href = url
      return 'https://' + a.hostname
    },
    shareItem (e) {
      if (typeof e !== 'undefined') {
        this.$emit('shareItem', e.currentTarget.getAttribute('data-type'))
        // console.log(e.currentTarget.getAttribute('data-type'))
      }
    }
  }
}
</script>
